import { render, staticRenderFns } from "./resolveEditForm.vue?vue&type=template&id=88c034e2"
import script from "./resolveEditForm.vue?vue&type=script&lang=js"
export * from "./resolveEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports